/**
 * Utility functions for displaying information, warnings, and errors
 * in Braintree payment processes.
 */

// Default element ID to use if none is provided
const DEFAULT_INFO_SECTION_ID = 'braintree-payment-info-section';

/**
 * Displays a message in the specified info section, and manages visibility class.
 *
 * @param {string} message - The message to display
 * @param {string} type - The type of message ('info', 'error', 'warning')
 * @param {string} infoSectionId - The ID of the element to display the message in
 * @param {string} bemBlock - name of the BEM block used in SCSS
 * @returns {void}
 */
export function displayPaymentInfo(
	message,
	type = 'info',
	infoSectionId = DEFAULT_INFO_SECTION_ID,
	bemBlock = 'braintree-payment-info-section',
) {
	const infoSection = document.getElementById(infoSectionId);
	if (!infoSection) return;

	infoSection.innerHTML = '';
	infoSection.classList.remove('hidden');
	infoSection.classList.add(bemBlock);

	const messageElement = document.createElement('div');
	messageElement.className = `${bemBlock}__message ${bemBlock}__message--${type}`;
	messageElement.innerText = message;

	infoSection.appendChild(messageElement);
}

/**
 * Clears the info section and hides it.
 *
 * @param {string} infoSectionId - The ID of the element to clear
 * @returns {void}
 */
export function clearPaymentInfo(infoSectionId = DEFAULT_INFO_SECTION_ID) {
	const infoSection = document.getElementById(infoSectionId);
	if (infoSection) {
		infoSection.innerHTML = '';
		infoSection.classList.add('hidden');
		infoSection.classList.remove(infoSectionId);
	}
}

/**
 * Displays an error message in the info section
 *
 * @param {string} message - The error message to display
 * @param {string} infoSectionId - The ID of the element to display the message in
 * @returns {void}
 */
export function displayPaymentError(
	message,
	infoSectionId = DEFAULT_INFO_SECTION_ID,
) {
	displayPaymentInfo(message, 'error', infoSectionId);
}

/**
 * Displays a warning message in the info section
 *
 * @param {string} message - The warning message to display
 * @param {string} infoSectionId - The ID of the element to display the message in
 * @returns {void}
 */
export function displayPaymentWarning(
	message,
	infoSectionId = DEFAULT_INFO_SECTION_ID,
) {
	displayPaymentInfo(message, 'warning', infoSectionId);
}
